import { ExemplosVerticalFieldModel } from '@mchat-rf/consulta-seguimento/components/ExemplosVerticalField'
import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { ConsultaSeguimentoAplicacaoItemModel } from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta01ExemplosEnum {
  OLHA_PARA_OBJETO = 'OLHA_PARA_OBJETO',
  APONTA_PARA_OBJETO = 'APONTA_PARA_OBJETO',
  OLHA_E_COMENTA_SOBRE_OBJETO = 'OLHA_E_COMENTA_SOBRE_OBJETO',
  OLHA_QUANDO_GENITOR_APONTA = 'OLHA_QUANDO_GENITOR_APONTA',
  IGNORA_VOCE = 'IGNORA_VOCE',
  OLHA_AO_REDOR = 'OLHA_AO_REDOR',
  OLHA_PARA_DEDO_DO_GENITOR = 'OLHA_PARA_DEDO_DO_GENITOR',
}

export interface ConsultaSeguimentoPergunta01Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_01_HEADER?: SimNaoEnum
  PERGUNTA_01_EXEMPLOS?: ExemplosVerticalFieldModel<ConsultaSeguimentoPergunta01ExemplosEnum>
  PERGUNTA_01_MAIOR_FREQUENCIA?: PassouFalhouEnum
}
